'use client';
import { FC, useEffect, useState } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import { useAppSelector, useTranslation, useWindowDimensions } from '@/hook';
import { HelpOutline } from '@mui/icons-material';
import colors from '@/theme/colors.module.scss';
import { Tick } from '../../../../public/Images';
import Image from 'next/image';
import styles from './styles.module.scss';
import { useAnalytics } from '@/integrations';
import { CarDetailsType, sourceScreenTypes } from '@/types';
import PriceBreakdownModal from '@/components/car-details/CarProfileNew/CarInfoSection/priceBreakdownSection/price-breakdown-modal.component';
import PriceBreakdownBottomsheet from '@/components/car-details/CarProfileNew/CarInfoSection/priceBreakdownSection/price-breakdown-bottomsheet.component';

const WhatsIncludedV2: FC<{
    hideText?: boolean;
    hideButton?: boolean;
    hideIcon?: boolean;
    hideToolTip?: boolean;
    carDetails?: CarDetailsType;
    registrationFees?: number;
    hasTrackEvent?: boolean;
}> = ({
    hideToolTip = false,
    hideText = false,
    hideButton = false,
    hideIcon = false,
    carDetails,
    hasTrackEvent = false,
}) => {
    const { t, IS_RTL } = useTranslation();
    const { selectedCar } = useAppSelector(state => state.checkout);
    const [openPriceBreakdownModal, setOpenPriceBreakdownModal] =
        useState(false);
    const [sourceScreen, setSourceScreen] = useState('');
    const { IS_DESKTOP } = useWindowDimensions();
    const { trackEvent } = useAnalytics();
    const [carDetailsTemp, setCarDetailsTemp] = useState(carDetails);

    const { bookingSteps, activeStep } = useAppSelector(
        state => state.checkout
    );
    useEffect(() => {
        if (!carDetailsTemp) {
            setCarDetailsTemp(selectedCar);
        }
    }, [carDetailsTemp]);
    useEffect(() => {
        const currentURL = window.location.href;
        if (currentURL.includes('checkout')) {
            if(bookingSteps[activeStep].title === 'verification') {
                setSourceScreen(sourceScreenTypes.VERIFICATION);
            }else{
                setSourceScreen(sourceScreenTypes.CHECKOUT);
            }
        } else if (currentURL.includes('thank-you')) {
            setSourceScreen(sourceScreenTypes.THANK_YOU);
        } else if (currentURL.includes('financing-submitted')) {
            setSourceScreen(sourceScreenTypes.THANK_YOU_FINANCING);
        } else if (currentURL.includes('financing')) {
            setSourceScreen(sourceScreenTypes.FINANCING);
        }
    }, [activeStep]);

    return (
        <>
            {carDetailsTemp && (
                <>
                    <div className={styles.container}>
                        {!hideIcon && (
                            <Image
                                src={Tick}
                                width={16}
                                height={16}
                                alt="check-box"
                            />
                        )}
                        <div
                            className={`${styles.containerInner} ${styles.btn}`}
                            onClick={() => {
                                setOpenPriceBreakdownModal(true);
                                hasTrackEvent &&
                                    trackEvent(
                                        'Action: Click On Price Breakdown',
                                        {
                                            carName:
                                                carDetailsTemp.sfVehicleName,
                                            make: carDetailsTemp.make,
                                            model: carDetailsTemp.model,
                                            year: carDetailsTemp.year,
                                            kilometers:
                                                carDetailsTemp.kilometers,
                                            trim: carDetailsTemp.trim?.en,
                                            transmission:
                                                carDetailsTemp.transmission,
                                            color: carDetailsTemp.color,
                                            price: carDetailsTemp.sylndrSellingPrice,
                                            bodyStyle: carDetailsTemp.bodyStyle,
                                            newlyAdded:
                                                carDetailsTemp.isNewlyAdded &&
                                                !(
                                                    carDetailsTemp.isReserved ||
                                                    carDetailsTemp.isPurchaseInProgress
                                                ),
                                            sourceScreen,
                                        }
                                    );
                            }}
                        >
                            <div className={styles.containerInnerText}>
                                {!hideText && (
                                    <Typography
                                        color={colors.gray600}
                                        variant="captionMedium"
                                    >
                                        {t('whatsIncluded.outerText')}
                                    </Typography>
                                )}
                                {!hideButton && (
                                    <div className={styles.viewMoreContainer}>
                                        <Typography
                                            color={colors.primary700}
                                            className={styles.viewBenefits}
                                            variant="captionSemiBold"
                                        >
                                            {t('whatsIncluded.outerTextButton')}
                                        </Typography>
                                        {!hideToolTip && (
                                            <HelpOutline
                                                sx={{
                                                    color: colors.primary700,
                                                    width: '16px',
                                                    height: '16px',
                                                    transform: IS_RTL
                                                        ? 'scaleX(-1)'
                                                        : '',
                                                }}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {IS_DESKTOP && carDetailsTemp ? (
                        <PriceBreakdownModal
                            carDetails={carDetailsTemp}
                            openPriceBreakdownModal={openPriceBreakdownModal}
                            setOpen={setOpenPriceBreakdownModal}
                            t={t}
                        />
                    ) : (
                        <PriceBreakdownBottomsheet
                            carDetails={carDetailsTemp}
                            openPriceBreakdownModal={openPriceBreakdownModal}
                            setOpen={setOpenPriceBreakdownModal}
                            t={t}
                            continueButton={true}
                        />
                    )}
                </>
            )}
        </>
    );
};
export default WhatsIncludedV2;
